module.exports = __webpack_public_path__ + "img/mobile-home-banner-3.fe6c8d4a.png";